const removeDangerMessage = () => {
    const userFields = document.getElementsByClassName('admin__add__field');

    for(const userField of userFields) {
        userField.classList.remove('admin__add__field__dangerous');
    }
}
export default removeDangerMessage;